module.exports = __webpack_public_path__ + "img/timezone.90636296.svg";